module.exports = __webpack_public_path__ + "img/daily_end.be075079.png";